import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { createItemPath, createItemParams, stringifyItemParams } from './helpers';
import { IItemSuggestion, IItemFilter } from './types';
import LoadingIcon from '../Shared/LoadingIcon';
import t from './locales';

const ItemSummaryView = styled.a`
  background-color: var(--gray0);
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0.5em 1em;
  box-shadow: 0 4px 15px rgba(53,118,172,0.15);
  margin-right: 0.5em;
  color: var(--gray900);
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid var(--gray0);
  cursor: pointer;
  &:last-of-type {
    margin-right: 0;
  }
  &:hover {
    color: var(--gray900);
    background-color: var(--gray100);
    text-decoration: none;
  }
  &.loading {
    box-shadow: none;
    background-color: var(--gray0);
    border: 1px solid var(--gray300);
    cursor: default;
  }
  &.disabled {
    box-shadow: none;
    background-color: var(--gray100);
    border: 1px solid var(--gray300);
    cursor: default;
  }
  i {
    font-size: 2em;
    color: var(--blue500);
    margin-right: 0.5em;
  }
  .summary {
  }
  .label, .count {
    display: block;
  }
  .label {
  }
  .count {
    font-size: 0.75em;
  }
  @media (max-width: 480px) {
    i.filter-icon {
      display: none;
    }
  }
`;

interface IProps {
  isLoading: boolean;
  icon: string;
  count?: number;
  filter: IItemFilter;
  suggestion: IItemSuggestion;
}

const ItemSummary: React.FC<IProps> = (props) => {
  const { isLoading, icon, filter, count, suggestion } = props;
  const [loading, setLoading] = useState<boolean>(isLoading);
  const path = createItemPath(suggestion);
  const params = createItemParams(suggestion ? suggestion.type : null, filter);
  const fullPath = [path.join(''), '?', stringifyItemParams(params)].join('');

  function handleClick() {
    if (count === 0) { return; }
    if (loading) { return; }
    setLoading(true);
    window.location.href = fullPath;
  }

  function renderCount() {
    if (count == null) { return null };
    let countLabel: string = '';
    if (suggestion == null) {
      countLabel = t.countResorts({ count: `${count}+` });
    } else {
      countLabel = suggestion.type === 'resort' ? t.countResortItems({ count }) : t.countResorts({ count });
    }
    return (
      <span className="count">
        {countLabel}
      </span>
    );
  }

  const classNames = [];
  if (loading) { classNames.push('loading'); }
  if (count === 0) { classNames.push('disabled'); }

  return (
    <ItemSummaryView key={`summary-${icon}`} onClick={handleClick} className={classNames.join(' ')}>
      {loading ?
        <div style={{ textAlign: 'center', width: '100%' }}>
          <LoadingIcon style={{ fontSize: '1em' }} />
        </div> :
        <React.Fragment>
          <i className={`filter-icon ${icon}`} />
          <div className="summary">
            <span className="label">{t[filter] && t[filter]()}</span>
            {renderCount()}
          </div>
        </React.Fragment>
        }
    </ItemSummaryView>
  );
}

export default ItemSummary;
